export default {
  'and': 'and',
  'yes': 'Yes',
  'no': 'No',
  'confirmApprove': 'Please confirm you want to approve the company?',
  'confirmReject': 'Please confirm you want to reject the company?',
  'confirmAction': 'Confirm Action',
  'confirm': 'Confirm',
  'visible': 'Visible'
}



// WEBPACK FOOTER //
// ./src/i18n/en/common.js